import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as qs from 'qs';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseCrudService<T = any> {
  protected httpClient = inject(HttpClient);

  abstract controller: string;

  getPaginated<Y = T>(params?: object, endpoint = '') {
    const queryParams = params ? '?' + qs.stringify(params) : '';

    const response = this.httpClient.get<Y[]>(
      `${this.controller}${endpoint ? '/' + endpoint : ''}${queryParams}`,
    );

    return response;
  }

  get<Y = T>(params?: object, endpoint = '') {
    const queryParams = params ? '?' + qs.stringify(params) : '';

    // @ts-ignore
    const response = this.httpClient.get<Y>(
      `${this.controller}${endpoint ? '/' + endpoint : ''}${queryParams}`,
    );

    return response;
  }

  getBySlug<Y = T>(slug: string, params?: object) {
    const queryParams = params ? qs.stringify(params) : '';

    // @ts-ignore
    const response = this.httpClient.get<Y[]>(
      `${this.controller}?filters[slug]=${slug}&${queryParams}`,
    );

    return response;
  }

  create<Y = T, R = T>(
    body: Y,
    endpoint = '',
    params?: object,
    useData = false,
  ) {
    const queryParams = params ? '?' + qs.stringify(params) : '';

    let data: any = body;

    if (useData) {
      data = { data: body };
    }

    // @ts-ignore
    const response = this.httpClient.post<R>(
      `${this.controller}${endpoint ? '/' + endpoint : ''}${queryParams}`,
      data,
    );

    return response;
  }

  update<Y = T>(id: string, body: Partial<Y>, useData = false) {
    let data: any = body;

    if (useData) {
      data = { data: body };
    }
    // @ts-ignore
    const response = this.httpClient.put<Y>(`${this.controller}/${id}`, data);

    return response;
  }

  delete(id: string, endpoint = '') {
    const response = this.httpClient.delete(
      `${this.controller}/${endpoint}` + id,
    );

    return response;
  }

  bulkSoftDelete(ids: string[]) {
    return this.httpClient.delete(`${this.controller}/bulk-delete`, {
      params: {
        ids,
      },
    });
  }

  bulkUpdate(ids: string[], body: Partial<T>) {
    return this.httpClient.put(
      `${this.controller}/bulk-update/${JSON.stringify(ids)}`,
      { data: body },
    );
  }

  upload(files: File | FileList | File[]): Observable<any[]> {
    let formData: FormData = new FormData();

    if (files instanceof File) {
      formData.append(`files`, files);
    } else if (Array.isArray(files) || files instanceof FileList) {
      for (let key in files) {
        let file = files[key];

        if (file instanceof File) {
          formData.append(`files`, file);
        }
      }
    }

    return this.httpClient.post<any[]>('uploads', formData);
  }

  deleteFile(id: string) {
    return this.httpClient.delete(`upload/files/${id}`);
  }
}
